import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { VscLoading } from 'react-icons/vsc';

const CHART_TYPES = [
    { value: 'bar', label: 'Bar Chart' },
    { value: 'line', label: 'Line Chart' },
    { value: 'pie', label: 'Pie Chart' },
    { value: 'area', label: 'Area Chart' },
    { value: 'scatter', label: 'Scatter Plot' },
];

const TIME_RANGE_OPTIONS = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '30days', label: 'Last 30 Days' },
    { value: '90days', label: 'Last 90 Days' },
    { value: '6months', label: 'Last 6 Months' },
    { value: '1year', label: 'Last Year' },
];

const UpdateChannelChartModal = React.memo(({ show, onHide, chart, onUpdate }) => {
    const [isBusy, setIsBusy] = useState(false);
    const [updateForm, setUpdateForm] = useState({
        timeRange: '30days',
        chartType: 'bar',
    });
    useEffect(() => {
        if (chart) {
            setUpdateForm({
                timeRange: chart?.timeRange || (chart?.extraInfo || {})?.timeRange || '30days',
                chartType: chart?.chartType || 'bar',
            });
        }
    }, [chart, show]);

    const handleSubmit = async () => {
        try {
            setIsBusy(true);
            if (onUpdate) {
                await onUpdate(chart, updateForm);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsBusy(false);
        }
    };

    if (!chart) return null;

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Update Chart</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Time Range</Form.Label>
                        <Form.Control
                            as="select"
                            value={updateForm.timeRange}
                            onChange={(e) => setUpdateForm({ ...updateForm, timeRange: e.target.value })}
                        >
                            {TIME_RANGE_OPTIONS.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Chart Type</Form.Label>
                        <Form.Control
                            as="select"
                            value={updateForm.chartType}
                            onChange={(e) => setUpdateForm({ ...updateForm, chartType: e.target.value })}
                        >
                            {CHART_TYPES.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={isBusy}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={isBusy}>
                    {isBusy ? (
                        <>
                            <VscLoading className="spin mr-2" size={16} />
                        </>
                    ) : (
                        'Update Chart'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
});

export default UpdateChannelChartModal;
